function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_893:73)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5414 14.7088H15.3451C15.5778 14.7052 15.7945 14.8274 15.9119 15.0286C16.0294 15.2299 16.0294 15.4789 15.9119 15.6801C15.7945 15.8814 15.5778 16.0036 15.3451 15.9999H0.654931C0.422183 16.0036 0.205529 15.8814 0.0880837 15.6801C-0.0293612 15.4789 -0.0293612 15.2299 0.0880837 15.0286C0.205529 14.8274 0.422183 14.7052 0.654931 14.7088H2.45936V11.4326C2.45971 11.0765 2.7477 10.7877 3.10334 10.7869H3.92757V8.00028C3.92793 7.64386 4.2164 7.35501 4.57235 7.35466H5.39659V5.54867C5.39703 5.19232 5.68547 4.90356 6.04137 4.90321H6.37598V2.60681C6.37634 2.25048 6.66474 1.9617 7.0206 1.96135H7.35522V0.645623C7.35522 0.289055 7.6439 0 8 0C8.3561 0 8.64478 0.289055 8.64478 0.645623V1.96135H8.97908C9.3351 1.96152 9.62374 2.25033 9.62418 2.60681V4.90321H9.95879C10.3146 4.90365 10.603 5.19238 10.6034 5.54867V8.82559H11.4278C11.7837 8.82603 12.0721 9.11485 12.0724 9.47121V12.7481H12.8968C13.2527 12.7486 13.5411 13.0374 13.5414 13.3937V14.7088ZM5.21686 8.64575V10.8058C5.50436 10.8775 5.70623 11.1359 5.70648 11.4326V14.7088H6.37587V8.64575H5.21686ZM7.66598 4.90302V3.25224H8.33521V4.90302H7.66598ZM10.2931 13.3937C10.2934 13.097 10.4953 12.8387 10.7827 12.7669V10.1166H9.62368V14.7088H10.2931V13.3937Z",
  fill: "#99A6B0"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_893:73"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

const SvgXxlargeGray = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXxlargeGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xxlarge-gray.28fdda1d.svg";
export { ForwardRef as ReactComponent };